import React, { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HealthCheck from "./pages/HealthCheck";
import Troubleshooting from "./pages/Troubleshooting";
import { Loader } from "@vds/loaders";

// set jenkins build info
window.buildInfo = {
  buildDate: process?.env?.buildDate,
  buildNumber: process?.env?.buildNumber,
  branch: process?.env?.branch,
}


export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  },
});

const isHealthCheck = window?.isHealthCheck;

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loader />}>
        {isHealthCheck ? <HealthCheck /> : <Troubleshooting />}
      </Suspense>
    </QueryClientProvider>
  );
};

export default App;
